export default "__VITE_ASSET__BP4BD5nO__"